module.exports = __webpack_public_path__ + "img/video5.d973a331.jpg";